<template>
  <div class="voted">
    <h2 class="page-title">
      <img
        :src="textSeries"
        class="page-title-text"
      >
    </h2>
    <div class="hero">
      <hero-image>
        <template v-slot:images>
          <div class="hero-image">
            <img
              :src="heroImage"
              height="320"
              width="320"
            >
          </div>
        </template>
      </hero-image>
      <hero-name :heroName="hero ? hero.name : ''">
        <template v-slot:hero-name>
          <!--TODO: 翻訳対応-->
          <span v-html="$t('text002', { hero_name: hero ? hero.name : '' }, 'localeVote')" />
        </template>
      </hero-name>
      <series-merge-notice
        v-if="hero && hero.isSamePerson"
        class="same_text"
        :hero="hero"
      />
    </div>
    <div class="bg-footer">
      <sns-share share-text="footer.share.voted" :replace-text="replaceText">
        <img :src="require(`@images/hero/${this.$route.params.lang}/txt_voted-share.png`)" />
      </sns-share>

      <div class="buttons">
        <button @click="goToHeroPage">
          <img
            :src="require(`@images/common/${this.$route.params.lang}/btn_back.png`)"
            height="112"
            width="108"
          >
        </button>
        <button @click="goToMypage">
          <img
            :src="require(`@images/hero/${this.$route.params.lang}/btn_mypage.png`)"
            height="113"
            width="500"
          >
        </button>
      </div>
      <p class="note" v-html="$t('text003', null, 'localeVote')" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Api from '@libraries/api/'
import RequestHero from '@requests/hero'
import ModelModal from '@models/modal'
import { validatelocale } from '@constants'

import HeroImage from '@components/hero/hero-image'
import HeroName from '@components/hero/hero-name'
import SeriesMergeNotice from '@components/global/vote-series-merge-notice'
import SnsShare from '@components/global/sns-share.vue'
import modalNALinkForMypage from '@components/modals/modal-na-link-for-mypage'
import localeVote from '@locales/vote'
import localeModal from '@locales/modal'

export default {
  name: 'voted',
  $messages: {localeVote, localeModal},
  components: {
    HeroImage,
    HeroName,
    SeriesMergeNotice,
    SnsShare,
  },
  data(){
    return {
      hero: null,
      baseSeriesName: null,
    }
  },
  created() {
    this.getHero(this.$route.params)
  },
  watch: {
    '$route.params.lang'(){
      this.getHero(this.$route.params)
    }
  },
  computed: {
    ...mapGetters('login', ['isLogin']),
    replaceText() {
      const params = this.$route.params
      const url = `${location.origin}/${params.lang}/series/${params.seriesId}/heroes/${params.heroId}/voted?hero_id=${params.heroId}`
      return {
        hero_name: this.hero ? this.hero.name : '',
        url: url
      }
    },
    textSeries(){
      if (!this.hero) return
      return require(`@images/series/${this.$route.params.lang}/txt_series-${this.hero.seriesId}.png`)
    },
    heroImage() {
      if (!this.hero) return
      return require(`@images/hero/faces/${this.hero.id}.png`)
    },
  },
  methods: {
    ...mapActions('modal', ['showModal']),
    async getHero(params){
      const cookieCheck = await validatelocale(this.$route.params.lang)
      //MEMO: cookie と path のlocaleが同じかどうかをチェック エラー時には強制リロード
      if (cookieCheck) {
        Api.call(new RequestHero({ seriesId: params.seriesId, heroId:params.heroId }))
        .then((hero) => {
          this.hero = hero
        })
        .catch(({error}) => {
          throw error
        })
      } else {
        location.reload()
      }
    },
    goToHeroPage() {
      this.$router.push(`/${this.$route.params.lang}/series/${this.$route.params.seriesId}/heroes/${this.$route.params.heroId}`)
      window.scrollTo(0, 0)
    },
    goToMypage() {
      if(this.isLogin) {
        this.$router.push(`/${this.$route.params.lang}/mypage`)
        window.scrollTo(0, 0)
      } else {
        this.showModal(new ModelModal({ component: modalNALinkForMypage }))
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.voted {
  padding: 40px 0 0;
}
.page-title {
  background-image: url(~@images/bg_page-title.png);
  background-repeat: no-repeat;
  background-size: 100% auto;
  height: 60px;
  width: 608px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 20;
  &-text {
    margin-top: -8px;
  }
}
.hero {
  padding: 0 0 40px;
  margin-top: -60px;
  .hero-image-wrapper {
    background: none;
    font-size: $fs-large;
    margin: -130px auto 20px;
    width: 606px;
    height: 611px;
    position: relative;
    &::before {
      content: "";
      display: block;
      width: 606px;
      height: 611px;
      background-image: url(~@images/vote/bg_hero-voted.png);
      background-repeat: no-repeat;
      background-position: center;
      position: absolute;
      left: 0;
      top: 0;
      animation: spin 20s linear infinite;
    }
  }

  .hero-image {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .hero-name {
    margin-top: -160px;
  }
}
.voted-text {
  background-image: url(~@images/bg_hero-text.png);
  background-repeat: no-repeat;
  background-position: center;
  font-size: $fs-xlarge;
  text-align: center;
  margin: -139px 0 20px;
  padding: 10px 40px;
}
.same_text {
  color: $color-red;
  padding: 0 40px;
}
.bg-footer {
  background-color: rgba(0, 0, 0, .5);
  padding-bottom: 55px;
}
.buttons {
  display: flex;
  margin: 40px auto 0;
  justify-content: center;
  > * {
    @include tap-event();
  }
}
.note {
  text-align: left;
  padding: 0 20px;
  margin-top: 20px;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(1turn);
  }
}
</style>
